import { render } from "./SimpleTable.vue?vue&type=template&id=295f00f0&scoped=true"
import script from "./SimpleTable.vue?vue&type=script&lang=js"
export * from "./SimpleTable.vue?vue&type=script&lang=js"

import "./SimpleTable.vue?vue&type=style&index=0&id=295f00f0&scoped=true&lang=css"
import "./SimpleTable.vue?vue&type=style&index=1&id=295f00f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295f00f0"]])

export default __exports__